export function scoreToFillColor(score) {
  if (score === 0 || score == null) return null;
  const abs = Math.abs(score);
  const opacity = 0.15 + (abs / 10) * 0.55;
  return score < 0
    ? `rgba(220, 38, 38, ${opacity.toFixed(2)})`
    : `rgba(22, 163, 74, ${opacity.toFixed(2)})`;
}

export function scoreToBorderColor(score) {
  if (score === 0 || score == null) return '#94a3b8';
  return score < 0 ? '#dc2626' : '#16a34a';
}

export function scoreToLabel(score) {
  const n = Math.round(Number(score));
  if (n <= -7) return 'Avoid harvesting where possible';
  if (n <= -3) return 'Conservation priority';
  if (n <= -1) return 'Use additional care';
  if (n === 0) return 'No current local guidance';
  if (n <= 2)  return 'Generally stable';
  if (n <= 6)  return 'Good local availability';
  return 'Community harvest focus';
}

export function scoreBand(score) {
  const n = Math.round(Number(score));
  if (n <= -7) return 'critical';
  if (n <= -3) return 'concern';
  if (n <= -1) return 'caution';
  if (n === 0) return 'neutral';
  if (n <= 2)  return 'stable';
  if (n <= 6)  return 'good';
  return 'focus';
}
